/**
 * Walk the active route component tree and call refreshPortalPage() where defined.
 * @param {import('vue').default} vm - route view instance (e.g. App's router-view ref)
 * @returns {boolean} true if a handler ran
 */
export function invokePortalRefresh(vm) {
  if (!vm) {
    return false;
  }
  const queue = [vm];
  while (queue.length) {
    const current = queue.shift();
    if (typeof current.refreshPortalPage === 'function') {
      current.refreshPortalPage();
      return true;
    }
    const children = current.$children || [];
    for (let i = 0; i < children.length; i += 1) {
      queue.push(children[i]);
    }
  }
  return false;
}
